import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { NotesSVG } from '@common_components/svg/notes.svg';

const NotesIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <NotesSVG />
    </div>
  );
};

export { NotesIcon };
